import { styled } from "~/common/mui";
import { C_ON_TERTIARY_CONTAINER, C_TERTIARY_CONTAINER } from "~/common/components/icon/Colors";
import BallBearingIcon from "~/common/mui/icons/BallBearing";

interface Props {
  className?: string;
  anchor?: "left" | "right" | "top" | "bottom";
}

const Root = styled("div", {
  shouldForwardProp: (prop) => prop !== "anchor",
})<{ anchor?: Props["anchor"] }>(({ theme, anchor }) => ({
  display: "flex",
  padding: theme.spacing(1, 2),
  borderRadius: theme.spacing(0.5),
  gap: theme.spacing(1),
  background: C_TERTIARY_CONTAINER,
  color: C_ON_TERTIARY_CONTAINER,
  alignItems: "center",
  ...theme.typography.labelMedium,
  ...(anchor === "left" && {
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
  }),
  ...(anchor === "right" && {
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
  }),
  ...(anchor === "top" && {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
  }),
  ...(anchor === "bottom" && {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
  }),
}));

export const FCCTag = (props: Props) => {
  return (
    <Root className={props.className} anchor={props.anchor}>
      <span>Free Capacity</span>
      <BallBearingIcon  />
    </Root>
  );
};
